import React, { useEffect, useRef, useState } from "react";
import PageHeading from "../common/PageHeading";
import {
	Facebook,
	Info,
	Instagram,
	LinkedIn,
	Numpad,
	PeopleIcon,
	Phone,
	Pinterest,
	Share,
	Star,
	TikTok,
	Twitter,
	User,
	User_Second,
	Whatsapp,
	Youtube,
} from "../../utils/SvgComponents";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import CustomButton from "../common/button/Button";
import CustomCard from "../common/card/Card";
import { getDataFromStore } from "../../utils/CookiesUtils";
import { EVENT_BASEURL, LOGIN_DATA } from "../../utils/Constants";
import { apiHandler } from "../../utils/apiHandler";
import { motion } from "framer-motion";
const SelfAboutUs = () => {
	const nextBtn = useRef();
	const prevBtn = useRef();
	const [response, setResponse] = useState();
	const [isSticky, setIsSticky] = useState(false);
	const [newPage, setNewPage] = useState(0)
	const [loaded, setLoaded] = React.useState(false);
	let animationFrameId = null;
	const pathArray = window.location.pathname.split("/").filter(Boolean);
	let username = "";
	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		username = pathArray[1];
	} else {
		username = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${username}`))
	console.log(data);
	const eventOwner = data?.eventOwner;
	useEffect(() => {
		const fetchSelfAboutUs = async () => {
			console.log("hii")
			try {
				const res = await apiHandler.post("/admin/aboutus/fetchBranding", {
					eventOwner: eventOwner,
				});
				if (res) {
					setResponse(res.data);
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};
		fetchSelfAboutUs();
	}, [])



	useEffect(() => {
		const handleScroll = () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			animationFrameId = requestAnimationFrame(() => {
				const outerElement = document.querySelector('.scroll-bar');
				if (outerElement) {
					const scrollPosition = outerElement.scrollTop;
					setIsSticky(scrollPosition > 0);
				}
			});
		};

		const outerElement = document.querySelector('.scroll-bar');
		if (outerElement) {
			outerElement.addEventListener('scroll', handleScroll);
			handleScroll(); // Initial check

			return () => {
				outerElement.removeEventListener('scroll', handleScroll);
				if (animationFrameId) {
					cancelAnimationFrame(animationFrameId);
				}
			};
		}
	}, []);

	const changePage = (page) => {
		setNewPage(page)
		if (page === 0) {
			if (index !== page) {
				prevBtn.current.click();
			}
		} else {
			if (index !== page) {
				nextBtn.current.click();
			}
		}
	};

	const [index, setIndex] = useState(0);
	const containerVariants = {
		hidden: {},
		show: {
			transition: {
				staggerChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
	};
	let newUrl = ''

	if (response?.selfBranding) {
		newUrl = 'https://admin.welcometowedding.com/branding/'
	}
	else {
		newUrl = 'https://admin.welcometowedding.com/service/'
	}
	let backImgurl = newUrl + (response?.userBgImg?.replace(/ /g, "%20"))
	let logoUrl = newUrl + (response?.userLogo?.replace(/ /g, "%20"))
	const tagline = response?.tagline || "";
	const breakAfter = 29;

	const firstLine = tagline.slice(0, breakAfter);
	const secondLine = tagline.slice(breakAfter);

	return (
		<div style={{ zIndex: '333333', backgroundColor: 'white', height: '100vh' }}>
			<div className="hidden sm:block h-screen overflow-hidden">
				<div className="grid grid-cols-12">
					<div className="col-span-5 relative h-full overflow-hidden text-center">

						{/* Blur → Clear Animated Background */}
						{response?.userBgImg && <img
							src={backImgurl}
							onLoad={() => setLoaded(true)}
							className={`
				w-full h-full object-cover absolute inset-0 
				transition-all duration-[1200ms] ease-out 
				${loaded ? "blur-0 scale-100 opacity-100" : "blur-xl scale-105 opacity-0"}
			`}
							alt=""
						/>}

						{/* Black gradient overlay */}
						<div className="absolute inset-0 bg-black/50 flex flex-col justify-between items-center z-10">

							{/* CENTER CONTENT */}
							<div className="h-full flex flex-col justify-center items-center">

								{/* LOGO */}
								<div className="rounded-full overflow-hidden grid place-items-center pointer-events-none">
									{response?.userLogo && <img
										src={logoUrl}
										onLoad={() => setLoaded(true)}
										className={`
				w-[188px] h-[188px] object-cover
				transition-all duration-[1200ms] ease-out
				${loaded ? "blur-0 scale-100 opacity-100" : "blur-xl scale-105 opacity-0"}
				
			`}
										alt=""
									/>}
								</div>

								{/* BRANDING NAME */}
								<div className="text-white capitalize text-[37px] font-medium py-[15px] tracking-[1.2px]">
									{response?.brandingName}
								</div>

								{/* LINES */}
								<div className="text-white text-[20px] leading-[35px]">
									{firstLine} <br />
									{secondLine}
								</div>

								{/* CONTACT INFO */}
								<div className="text-white text-[25px] flex flex-col items-center pt-[15px] gap-3">
									<div className="flex items-center font-medium gap-2">
										<User width="25" fill="white" /> {response?.contactName}
									</div>
									<div className="flex items-center font-medium gap-2">
										<Phone width="25" fill="white" /> {response?.contactNumber}
									</div>
								</div>
							</div>

							{/* SOCIAL ICONS */}
							<div className="flex flex-col justify-center items-center gap-3 pb-[30px]">
								<div className="text-white capitalize text-[20px]">
									Follow Us On Social Media
								</div>

								<div className="flex justify-center items-center gap-[23px] p-3">

									{response?.instaLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.instaLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<Instagram width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.fbLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.fbLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<Facebook width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.ybLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.ybLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<Youtube width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.waLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.waLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<Whatsapp width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.linkedInLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.linkedInLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<LinkedIn width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.pinterestLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.pinterestLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<Pinterest width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.tiktokLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.tiktokLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<TikTok width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response?.twitterLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response?.twitterLink} target="_blank">
												<CustomButton>
													<div className="p-2">
														<Twitter width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

								</div>
							</div>
						</div>
					</div>
					<div className="col-span-7">
						<div className="h-screen overflow-x-auto scroll-bar">
							<div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} style={{ position: 'sticky', top: 0, zIndex: '1', backgroundColor: 'white', textAlign: 'center' }}>
								<PageHeading title={"Our Services"} />
							</div>
							<motion.div
								className=""
								variants={containerVariants}
								initial="hidden"
								animate="show"
							>
								<div className="grid grid-cols-2 mt-[16px] px-[15px]">

									{response?.services.map((item) => (
										<motion.div
											key={index}
											variants={itemVariants}
											className="whiteripple cursor-pointer"
										>
											<div
												key={item}
												className=" "
											>
												<div
													className="m-[16px] p-[1rem] rounded-2xl"
													style={{
														boxShadow:
															"0px 0px 5px 2px rgba(0,0,0,0.2)",
													}}
												>
													<div className="flex justify-start items-center gap-[0.75rem] pb-2">
														<div className="bg-black w-[45px] h-[45px] rounded-full flex items-center justify-center">
															<img
																src={`https://welcometowedding.com/service/${item.brandServiceIcon}`}
																alt=""
																className="rounded-full"
																style={{

																	filter: "brightness(0) invert(1)",   // <-- makes icon white
																	WebkitFilter: "brightness(0) invert(1)"
																}}
																onError={(e) => {
																	e.target.src =
																		"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/600px-Instagram_icon.png";
																	e.target.onerror = null;
																}}
															/>
														</div>

														<div className="text-lg font-semibold black-color tracking-[0.2px] common-font">
															{item.heading}
														</div>
													</div>
													<div className="text-left common-font black-color tracking-[0.1px]">
														{item.description}
													</div>
												</div>
											</div>
										</motion.div>
									))}

								</div>
							</motion.div>
						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden h-svh overflow-hidden relative">

				{/* Animated Blur Background */}
				{response?.userBgImg && <img
					src={backImgurl}
					onLoad={() => setLoaded(true)}
					className={`
                transition-all duration-[1200ms] ease-out
                ${loaded ? "blur-0 scale-100 opacity-100" : "blur-xl scale-105 opacity-0"}
                absolute inset-0 w-full h-full object-cover
            `}
					alt=""
				/>}
				{/* Dark Overlay */}
				<div className="absolute inset-0 bg-black/40" />

				{/* MAIN CONTENT LAYER */}
				<div className="relative h-full flex flex-col">
					<Swiper
						grabCursor={true}
						slidesPerView={1}
						onRealIndexChange={(e) => setIndex(e.realIndex)}
						freeMode={true}
						autoHeight={true}
						keyboard={true}
						navigation={{
							enabled: true,
							nextEl: "#custom-next-button",
							prevEl: "#custom-prev-button",
						}}
						modules={[Navigation]}
						className="mySwiper about-us-mobile-slider flex-auto p-0"
						speed={500}
					>


						{/* PAGE 1 — ABOUT US */}
						<SwiperSlide>
							<div className="h-full px-10 overflow-y-auto text-center flex flex-col justify-between items-center">
								<div className="flex flex-col justify-center items-center flex-auto">

									{/* Animated Logo */}
									<div className="rounded-full w-[150px] h-[150px] overflow-hidden">


										{response?.userLogo && <img
											src={logoUrl}
											onLoad={() => setLoaded(true)}
											className={`
                transition-all duration-[1200ms] ease-out
                ${loaded ? "blur-0 scale-100 opacity-100" : "blur-xl scale-105 opacity-0"}
                w-full h-full object-cover rounded-full
            `}
											alt=""
										/>}
									</div>

									<div className="flex flex-col justify-center items-center gap-3">
										<div className="text-white capitalize text-[33px] font-medium pt-[15px]">
											{response?.brandingName}
										</div>

										<div className="text-white text-[18px] leading-7">
											{response?.tagline}
										</div>

										<div className="text-white flex flex-col items-center gap-[10px] text-[20px] font-medium">
											<div className="flex items-center gap-2">
												<User width="25" fill="white" />
												{response?.contactName}
											</div>
											<div className="flex items-center gap-2">
												<Phone width="25" fill="white" />
												{response?.contactNumber}
											</div>
										</div>
									</div>
								</div>

								{/* SOCIALS */}
								<div className="flex flex-col justify-center items-center gap-[15px] pt-[30px]">
									<div className="text-white capitalize text-[18px]">
										Follow Us On Social Media
									</div>
									<div className="flex justify-center items-center gap-[1.25rem] pb-[25px]">

										{response?.instaLink && (
											<a href={response?.instaLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<Instagram width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.fbLink && (
											<a href={response?.fbLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<Facebook width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.ybLink && (
											<a href={response?.ybLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<Youtube width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.waLink && (
											<a href={response?.waLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<Whatsapp width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.tiktokLink && (
											<a href={response?.tiktokLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<TikTok width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.twitterLink && (
											<a href={response?.twitterLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<Twitter width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.pinterestLink && (
											<a href={response?.pinterestLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<Pinterest width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}

										{response?.linkedInLink && (
											<a href={response?.linkedInLink} target="_blank">
												<div className="rounded-full border-[1.75px] border-white bg-black/65 overflow-hidden">
													<CustomButton>
														<div className="p-[7px]">
															<LinkedIn width="29" fill="white" />
														</div>
													</CustomButton>
												</div>
											</a>
										)}
									</div>
								</div>
							</div>
						</SwiperSlide>




						{/* PAGE 2 — SERVICES */}
						<SwiperSlide>
							<div className="p-[15px] relative overflow-y-auto h-full">
								{index === 1 && (
									<motion.div
										className="flex flex-col gap-[30px]"
										variants={containerVariants}
										initial="hidden"
										animate="show"
										key={index}
									>
										<div className="flex flex-col gap-[15px]">
											{response?.services?.map((item) => (
												<motion.div
													key={item.heading}
													variants={itemVariants}
													className="items-start whiteripple cursor-pointer"
												>
													<div
														className="rounded-lg p-[17px] bg-black/50 text-white"
													>
														<div className="flex items-center gap-3 pb-2">
															<div className="bg-white w-[40px] h-[40px] rounded-full flex items-center justify-center">
																<img
																	src={`https://welcometowedding.com/service/${item.brandServiceIcon}`}
																	width="35"
																	alt=""
																/>
															</div>
															<div className="text-lg font-[550]">
																{item.heading}
															</div>
														</div>

														<div className="text-[15px]">
															{item.description}
														</div>
													</div>
												</motion.div>
											))}
										</div>
									</motion.div>
								)}
							</div>
						</SwiperSlide>

					</Swiper>


					{/* BOTTOM NAVIGATION */}
					<div className="bg-black/65 flex">
						<CustomButton clicked={() => changePage(0)} flex="1">
							<div
								className="relative flex-1 py-[15px] text-white flex flex-col justify-center items-center gap-2"
							// onClick={() => changePage(0)}
							>
								<div
									className={`absolute top-0 right-0 h-[2px] bg-white transition-all duration-[3s] rotate-180 ${index === 0 ? "left-0" : "left-[unset]"
										}`}
								/>
								<div className="flex flex-col justify-center items-center gap-[7.5px]">
									<Info fill="white" width="30" />
									<div className="normal-case font-medium text-[16.5px]">
										About Us
									</div>
								</div>
							</div>
						</CustomButton>

						<CustomButton clicked={() => setTimeout(() => changePage(1), 50)} flex="1">
							<div
								className="relative flex-1 py-[15px] text-white flex flex-col justify-center items-center gap-2"
							// onClick={() => {
							//     setTimeout(() => changePage(1), 50);
							// }}
							>
								<div
									className={`absolute top-0 left-0 right-0 h-[2px] bg-white transition-[width] duration-[3s] ${index === 1 ? "w-full" : "w-0"
										}`}
								/>
								<div className="flex flex-col justify-center items-center gap-[7.5px]">
									<User_Second fill="white" width="30" />
									<div className="normal-case font-medium text-[16.5px]">
										Our Services
									</div>
								</div>
							</div>
						</CustomButton>
					</div>

				</div>
			</div>

			<div id="custom-next-button" ref={nextBtn}></div>
			<div id="custom-prev-button" ref={prevBtn}></div>
		</div>
	);
};

export default SelfAboutUs;
